export const VariableType = [
    {
        id: 0,
        text: 'FieldTypeString',
    },
    {
        id: 1,
        text: 'FieldTypeDate',
    },
    {
        id: 2,
        text: 'FieldTypeNumeric',
    }
];